<script setup lang="ts">
import sanitizeHtml from 'sanitize-html'

import { Employee, MediaImageFragment } from '~/api/graphql/generated'
import { Link } from '~/types'

const props = withDefaults(
  defineProps<{
    entity: Employee
    breadcrumbs: Link[]
  }>(),
  {
    breadcrumbs: () => [],
  },
)

const { t } = useI18n()

const data = {
  id: props.entity.id!,
  name: `${props.entity.fieldAcademicTitle ?? ''} ${props.entity.fieldFirstName} ${props.entity.fieldLastName}`,
  email: props.entity.fieldEmail ?? '',
  phone: props.entity.fieldPhone ?? '',
  position: sanitizeHtml(props.entity.fieldPosition?.[0]?.entity?.fieldWorkTitle ?? ''),
  description: props.entity.fieldDescription ?? '',
  link: {
    url: props.entity.entityUrl?.path || '',
    text: t('employee.list.teaser.cta'),
  },
  image: props.entity.fieldImage?.entity as MediaImageFragment,
}
</script>

<template>
  <Section class="section-employee" large>
    <EmployeeSingle :data="data" />
  </Section>
</template>
<style lang="scss" scoped>
.section.section-employee {
  @include fluid(margin-top, 32px, 48px);
}
</style>
